import React from 'react';
import { academicYears } from '../../../constants/academicYears';
import { relationTypes } from '../utils/columns';
import { IdCardsFiltersProps } from '../types/IdCardTypes';
import TextInputWithIcon from '../../../components/TextInputWithIcon';
import DropdownSelect from '../../../components/DropdownSelect';

const IdCardsFilters: React.FC<IdCardsFiltersProps> = ({
  academicYear,
  setAcademicYear,
  grade,
  setGrade,
  division,
  setDivision,
  typeOfRelation,
  setTypeOfRelation,
  name,
  setName,
  gradeOptions,
  divisionOptions,
  setHasSearched
}) => {
  const handleAcademicYearChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    setAcademicYear(e.target.value as string);
    setHasSearched(false);
  };

  const handleGradeChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    setGrade(e.target.value as string);
    setDivision('');
    setHasSearched(false);
  };

  const handleDivisionChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    setDivision(e.target.value as string);
    setHasSearched(false);
  };

  const handleRelationChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    const selectedLabel = e.target.value as string;
    const found = relationTypes.find(
      (relation) => relation.label === selectedLabel
    );
    setTypeOfRelation(found ? found.value : '');
    setHasSearched(false);
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const relationTypeLabel =
    relationTypes.find((relation) => relation.value === typeOfRelation)
      ?.label || '';

  return (
    <>
      <DropdownSelect
        label='Academic Year'
        name='academicYear'
        value={academicYear}
        onChange={handleAcademicYearChange}
        options={academicYears.map((y) => ({
          label: y.label,
          value: y.value
        }))}
        placeholder='Select Academic Year'
        sx={{
          minWidth: '120px !important'
        }}
      />

      <DropdownSelect
        label='Grade'
        name='grade'
        value={grade}
        required
        onChange={handleGradeChange}
        options={gradeOptions.map((o: any) => ({
          label: o.label,
          value: o.value
        }))}
        placeholder='Select'
        sx={{
          minWidth: '86px !important'
        }}
      />

      <DropdownSelect
        label='Division'
        name='division'
        value={division}
        required
        onChange={handleDivisionChange}
        options={divisionOptions.map((o: any) => ({
          label: o.label,
          value: o.value
        }))}
        placeholder='Select'
        disabled={!grade}
        sx={{
          minWidth: '86px !important'
        }}
      />

      <DropdownSelect
        label='Type of Relation'
        name='relation'
        value={relationTypeLabel}
        required
        onChange={handleRelationChange}
        options={relationTypes.map((r) => ({
          label: r.label,
          value: r.label
        }))}
        placeholder='Select'
        sx={{
          minWidth: '100px !important'
        }}
      />

      <TextInputWithIcon
        fullWidth
        size='small'
        value={name}
        onChange={handleNameChange}
        label='Student Name'
        required={false}
        placeholder='Student Name'
        sx={{
          '& .MuiInputBase-root': {
            height: '50px'
          }
        }}
      />
    </>
  );
};

export default IdCardsFilters;
